<template>
<div>
  <el-card>
    <template v-slot:header>
      <div>
        <span class="mr-[40px]">部门管理</span>
        <el-button type="primary" @click="refresh()">刷新</el-button>
      </div>
    </template>
    <el-tree :data="treeData" :props="treeProps" node-key="id" default-expand-all>
      <template v-slot="{ node, data }">
        <div class="department-item" @mouseenter="showButtons(data)" @mouseleave="hideButtons(data)">
          <span class="mr-2" >
          <i :class="data.id === 0?'el-icon-s-home':'el-icon-s-custom'"></i></span>
          <span :style="{'font-weight':data.id===0?'bold':'normal'}">{{ node.label }}</span>
          <div class="button-operation" v-show="data.showButtons">
            <el-button type="primary" size="mini" @click="add(data)">添加</el-button>
            <el-button type="primary" size="mini" @click="edit(data)" v-if="data.id>0">修改</el-button>
            <el-button type="danger" size="mini" @click="remove(data)" v-if="data.id>0">删除</el-button>
          </div>
        </div>
      </template>
    </el-tree>
  </el-card>

  <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="300px">
    <el-form :model="editItem" label-width="80px">
      <el-form-item label="上级部门">
        <el-input v-model="editItem.parentName" disabled></el-input>
      </el-form-item>
      <el-form-item label="名称">
        <el-input v-model="editItem.name" maxlength="32"></el-input>
      </el-form-item>
      <el-form-item label="权重">
        <el-input v-model.number="editItem.weight" validate-number maxlength="6"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="save()">保 存</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
import {
  fetchOrganizations,
  fetchDepartments, 
  addDepartment, 
  updateDepartment,
  deleteDepartment,
} from '@/api/api';

export default {
  name: "DepartmentPage",
  data() {
    return {
      organizations: [],
      departments: [],
      treeData: [],
      treeProps: {
        children: 'children',
        label: 'name',
      },
      dialogTitle: '',
      dialogVisible: false,
      editItem: {
        id: 0,
        name: "",
        weight: 0,
        parentId: 0,
        parentName: "",
        action:"",
      },
      userId: 0,
      userName: "",
      orgId: 0,
      orgName:"",
    };
  },

  async mounted() {
    this.userId = localStorage.getItem("uid")||"0"
    // if (this.userId === "0") {
    //   this.$router.push('/');
    //   return
    // }
    this.userName = localStorage.getItem("uname")||""
    try {
      let result = await fetchOrganizations(this.userId);
      console.log(result)
      if (result && result.data && result.data.data) {
       let that = this;
        result.data.data.forEach(element => {
          let item = {};
          item.id = "" + element.id;
          item.name = "" + element.name;
          that.organizations.push(item);
        })
      }
    }catch(e){
      console.log(e);
      return;
    }
    console.log(this.orgnizations)
    this.orgId = localStorage.getItem("oid")||"0"
    this.orgName = localStorage.getItem("oname")||"南京百市通数字科技有限公司"

    this.getDepartments();
  },

  methods: {
    getDepartments() {
      let that = this;
      fetchDepartments(that.userId, that.orgId).then(result => {
        try{
          that.departments=[];
          let data = result.data.data;
          let count = data.total;
          for (let i=0; i<count; i++) {
            let item = {}
            item.index = i+1;
            item.id = data.departments[i].id;
            item.name = data.departments[i].name;
            item.parent = data.departments[i].parent_id;
            item.org = data.departments[i].org_id;
            item.weight = data.departments[i].weight;
            that.departments.push(item);
          }
          that.departments[0].name = that.orgName
          that.departments[0].parent = -1;
          that.buildTreeData();
          
        }catch(e) {
          console.log(e);
        }
      })
      .catch(e => {
        console.error(e);
      });
    },

    buildTreeData() {
      const treeData = [];
      const departmentMap = {};
      this.departments.forEach((dept) => {
        const node = {...dept, children: []};
        departmentMap[dept.id] = node;
        if (dept.parent === -1) {
          treeData.push(node);
        } else {
          const parent = departmentMap[dept.parent];
          if( parent !== undefined) {
            node.parentName = parent.name;
            parent.children.push(node);
          }
        }
      });
      this.treeData = treeData;
    },

    refresh() {
      this.getDepartments();
    },

    add(department) {
      event.stopPropagation();
      this.editItem.id = 0; 
      this.editItem.name = "";
      this.editItem.weight = 0;
      this.editItem.parentId = department.id; 
      this.editItem.parentName = department.name; 
      this.editItem.action ="add",
      this.dialogTitle = '添加部门';
      this.dialogVisible = true;
    },

    edit(department) {
      event.stopPropagation();   
      this.editItem.id = department.id; 
      this.editItem.name = department.name;
      this.editItem.weight = department.weight;
      this.editItem.parentId = department.parent; 
      this.editItem.parentName = department.parentName; 
      this.editItem.action ="edit",
      this.dialogTitle = '编辑部门';
      this.dialogVisible = true;
    },

    save() {
      this.editItem.name = this.editItem.name.trim()
      if (this.editItem.name.length == 0) {
        this.$message.error("名称不能为空");
        return;
      }
      const data = JSON.stringify({
        "id": this.editItem.id,
        "name": this.editItem.name,
        "weight": this.editItem.weight,
        "parent_id": this.editItem.parentId,
        "org_id" : this.orgId
      });
      if( this.editItem.action == "add") {
        addDepartment(data).then(() =>{
          this.dialogVisible = false;
          this.$message({message: '添加成功',type: 'success'});
          this.getDepartments();
        }).catch((err)=> {
          this.$message.error(err);
        });
      } else {
        updateDepartment(data).then(() =>{
          this.dialogVisible = false;
          this.$message({message: '更新成功',type: 'success'});
          this.getDepartments();
        }).catch((err)=> {
          this.$message.error(err);
        });
      }
    },

    remove(department) {
      event.stopPropagation();
      this.$confirm("您确定要删除【" + department.name + "】吗？", '删除部门', {
          confirmButtonText: '确 定',
          cancelButtonText: '取 消',
          type: 'warning'
        }).then(() => {
          deleteDepartment(this.orgId, department.id).then(() =>{
            this.$message({message: '删除成功',type: 'success'});
            this.getDepartments();
          })
        }).catch((err) => {
          if (err == "cancel") {  
            return
          }
          this.$message.error(err);
        })
    },

    showButtons(data) {
      this.$set(data, "showButtons", true);
    },
    hideButtons(data) {
      this.$set(data, "showButtons", false);
    }
  }
};
</script>

<style scoped>
.department-item {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 8px;
  width:100%;
}

.button-operation {
  display: none;
}

.department-item:hover .button-operation {
  display: flex;
  padding-left:50px;
}

/deep/ .el-tree-node__content{
  height: 40px;
  font-size:14px;
}
</style>